import getConfig from 'next/config';

import { requestService } from 'shared/utils/services/requestService';
import { generateSpecialHeaders } from 'shared/utils/generateSpecialHeaders';

export async function logInUser({
  username,
  password,
  captchaToken = '',
  provider = '',
  forceViceroy = '',
  isAtoMitigationEnabled = false,
  webEnableGoogleRecaptcha = true,
  otp = '',
}) {
  const {
    publicRuntimeConfig: { SPIKE_KEY },
  } = getConfig();

  // force_viceroy can take different values, for now we care only to force a captcha response for testing
  const url = `/web-api/v1/login${forceViceroy === 'captcha' ? '?force_viceroy=captcha' : ''}`;

  return requestService({
    url,
    method: 'post',
    data: {
      username,
      password,
      captchaToken,
      provider,
      webEnableGoogleRecaptcha,
      otp,
    },
    ...(isAtoMitigationEnabled && { headers: generateSpecialHeaders(SPIKE_KEY) }),
    withCredentials: true,
  });
}
